import '../canUseDOM/76d48a76edca5d62d79d5106429b4776b8be4a3fd5647a862e2ca5f9c2bf7a20.cfe-internal.js';
import canUseDOM from '../canUseDOM/c67777c3ad1eb68171c13859212224771d86d89bae09127a82a280a9f9573215.cfe-internal.js';

var KEYBOARD_USER_CLASS = 'keyboard-user';
function getIsKeyboardUser() {
  return canUseDOM() && document.body.classList.contains(KEYBOARD_USER_CLASS);
}
function setIsKeyboardUser(newIsKeyboardUser) {
  if (!canUseDOM()) {
    return;
  }
  if (newIsKeyboardUser) {
    document.body.classList.add(KEYBOARD_USER_CLASS);
  } else {
    document.body.classList.remove(KEYBOARD_USER_CLASS);
  }
}
function enableKeyboardUserClass() {
  if (canUseDOM() && !window.keyboardUserListenersAdded) {
    window.keyboardUserListenersAdded = true;
    document.addEventListener('mousedown', function () {
      return setIsKeyboardUser(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.keyCode === 9) {
        setIsKeyboardUser(true);
      }
    });
  }
}

export { enableKeyboardUserClass, getIsKeyboardUser, setIsKeyboardUser };
